import { IntroStep } from './IntroStep';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- child component rendered inside tracked UnsupportedMarketRoute
export const UnsupportedMarketPage = ({
  onNotifyMe,
}: {
  onNotifyMe: () => void;
}) => (
  <IntroStep
    data-testid="unsupported-market"
    data-track-id="region.unsupported-market"
    data-track-impression
    title="We're not in your country just yet, but don't worry!"
    description="We are working on expanding Confidence to more countries. Click 'Notify me' so you can be the first to know when we make it to your country."
    buttonLabel="Notify me"
    onNext={onNotifyMe}
  />
);
